// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// import VueWorker from "vue-worker";
import App from "./App";
import router from "./router";
import store from "./store";
// import iView from 'iview'
import ViewUI from "view-design";
import i18n from "@/locale";
import config from "@/config";
import importDirective from "@/directive";
import { directive as clickOutside } from "v-click-outside-x";
import installPlugin from "@/plugin";
import "@/assets/icons/iconfont.css";
import TreeTable from "tree-table-vue";
import VOrgTree from "v-org-tree";
import "./index.less";
import "v-org-tree/dist/v-org-tree.css";
import "view-design/dist/styles/iview.css";
import { tableApis } from "@/libs/api.request"
import {
  hasPermission,
  getSelectData,
  changSelObj,
  fieldMap,
} from "@/utils/util";
import useMixin from '@/utils/mixin'

// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')
// const i18n = new VueI18n({
//   locale: localStorage.getItem("locale") || "zh", // 设置语言,如果本地存储了则用本地的,没有则默认 'en'
//   messages // set locale messages
// });

import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import VXETablePluginExportXLSX from "vxe-table-plugin-export-xlsx";

VXETable.use(VXETablePluginExportXLSX);
useMixin(Vue)
Vue.use(VXETable);

import Label from '@/base/common/component/label'
Vue.component(Label.name, Label)

Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value),
});
// Vue.use(ViewUI)
Vue.use(TreeTable);
Vue.use(VOrgTree);
// Vue.use(VueWorker);
/**
 * @description 注册admin内置插件
 */
installPlugin(Vue);
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false;
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config;

Vue.prototype.$globalUrl = "https://oms.vnlin.com";
Vue.prototype.$prviewUrl = "";

Vue.prototype.$hasPermission = hasPermission;
Vue.prototype.$sel = {
  getData: getSelectData,
  ToObj: changSelObj,
  keyMap: fieldMap,
};

// // 引入缓存函数
// import version from "@/utils/version";

// version.getAjax();

// setTimeout(() => {
//   version.getAjax();
// }, 10000 * 6);

/**
 * 注册指令
 */
importDirective(Vue);
Vue.directive("clickOutside", clickOutside);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  render: (h) => h(App),
});
